"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = Sidebar;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var use_permissions_1 = require("../../hooks/use-permissions");
var permissions_1 = require("../../interfaces/permissions");
// Icon components
function DashboardIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" }) }));
}
function OrganizationsIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" }) }));
}
function CustomersIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" }) }));
}
function RolesIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" }) }));
}
function UsersIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" }) }));
}
function ProductsIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" }) }));
}
function StockIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" }) }));
}
function OrdersIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" }) }));
}
function DisbursementsIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" }) }));
}
function ReportsIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" }) }));
}
function UssdIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.14 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" }) }));
}
function SettingsIcon() {
    return ((0, jsx_runtime_1.jsxs)("svg", { className: "h-5 w-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: [(0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" }), (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z" })] }));
}
var navItems = [
    {
        label: "Dashboard",
        path: "/dashboard",
        icon: (0, jsx_runtime_1.jsx)(DashboardIcon, {}),
    },
    {
        label: "Organizations",
        path: "/organizations",
        icon: (0, jsx_runtime_1.jsx)(OrganizationsIcon, {}),
        module: permissions_1.MODULES.ORGANIZATIONS,
    },
    {
        label: "Customers",
        path: "/customers",
        icon: (0, jsx_runtime_1.jsx)(CustomersIcon, {}),
        module: permissions_1.MODULES.CUSTOMERS,
    },
    {
        label: "Roles",
        path: "/roles",
        icon: (0, jsx_runtime_1.jsx)(RolesIcon, {}),
        module: permissions_1.MODULES.ROLES,
    },
    {
        label: "Users",
        path: "/users",
        icon: (0, jsx_runtime_1.jsx)(UsersIcon, {}),
        module: permissions_1.MODULES.USERS,
    },
    {
        label: "Products",
        path: "/products",
        icon: (0, jsx_runtime_1.jsx)(ProductsIcon, {}),
        module: permissions_1.MODULES.PRODUCTS,
    },
    {
        label: "Stock",
        path: "/stock",
        icon: (0, jsx_runtime_1.jsx)(StockIcon, {}),
        module: permissions_1.MODULES.STOCK,
    },
    {
        label: "Orders",
        path: "/orders",
        icon: (0, jsx_runtime_1.jsx)(OrdersIcon, {}),
        module: permissions_1.MODULES.ORDERS,
    },
    {
        label: "Disbursements",
        path: "/disbursements",
        icon: (0, jsx_runtime_1.jsx)(DisbursementsIcon, {}),
        module: permissions_1.MODULES.DISBURSEMENTS,
    },
    {
        label: "Reports",
        path: "/reports",
        icon: (0, jsx_runtime_1.jsx)(ReportsIcon, {}),
        module: permissions_1.MODULES.REPORTS,
    },
    {
        label: "USSD",
        path: "/ussd",
        icon: (0, jsx_runtime_1.jsx)(UssdIcon, {}),
        module: permissions_1.MODULES.USSD,
    },
    {
        label: "Settings",
        path: "/settings",
        icon: (0, jsx_runtime_1.jsx)(SettingsIcon, {}),
        module: permissions_1.MODULES.SYSTEM,
    },
];
function Sidebar(props) {
    var isOpen = props.isOpen, onClose = props.onClose;
    var location = (0, react_router_dom_1.useLocation)();
    var canAccess = (0, use_permissions_1.usePermissions)().canAccess;
    var isActive = function (path) {
        return location.pathname === path || location.pathname.startsWith("".concat(path, "/"));
    };
    var filteredNavItems = navItems.filter(function (item) {
        if (!item.module)
            return true;
        return canAccess(item.module);
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isOpen && (0, jsx_runtime_1.jsx)("div", { className: "fixed inset-0 z-40 bg-black/50 lg:hidden", onClick: onClose }), (0, jsx_runtime_1.jsxs)("aside", { className: "fixed left-0 top-0 z-50 h-screen w-64 transform bg-content1 shadow-lg transition-transform duration-300 ease-in-out lg:static lg:translate-x-0 ".concat(isOpen ? "translate-x-0" : "-translate-x-full"), children: [(0, jsx_runtime_1.jsx)("div", { className: "flex h-16 items-center justify-center border-b border-divider px-4", children: (0, jsx_runtime_1.jsx)("h1", { className: "text-xl font-bold text-primary", children: "Sky Airtime" }) }), (0, jsx_runtime_1.jsx)("nav", { className: "h-[calc(100vh-4rem)] overflow-y-auto p-4", children: (0, jsx_runtime_1.jsx)("ul", { className: "flex flex-col gap-1", children: filteredNavItems.map(function (item) { return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, { to: item.path, onClick: onClose, className: "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ".concat(isActive(item.path) ? "bg-primary text-primary-foreground" : "text-default-700 hover:bg-default-100"), children: [item.icon, (0, jsx_runtime_1.jsx)("span", { children: item.label })] }) }, item.path)); }) }) })] })] }));
}
